// Closed enum: callers used to pass raw t() keys in four incompatible conventions.
export const FARMER_VERIFY_HEADER = Object.freeze({
  DEFAULT: "DEFAULT",
  FARMER_PASSBOOK: "FARMER_PASSBOOK",
  SOIL_CARD: "SOIL_CARD",
});

const HEADER_KEY_MAP = {
  [FARMER_VERIFY_HEADER.DEFAULT]: ["FARMER_VERIFY.HEADER_DEFAULT", "Verify your account"],
  [FARMER_VERIFY_HEADER.FARMER_PASSBOOK]: ["FARMER_VERIFY.HEADER_FARMER_PASSBOOK", "Farmer Passbook"],
  [FARMER_VERIFY_HEADER.SOIL_CARD]: ["FARMER_VERIFY.HEADER_SOIL_CARD", "Verify Farmer Details"],
};

/**
 * @param {string} [headerId] - a FARMER_VERIFY_HEADER member, or undefined
 * @returns {[string, string]} [rewampNamespaceKey, englishDefaultValue]
 */
export const resolveFarmerVerifyHeader = (headerId) =>
  HEADER_KEY_MAP[headerId] || HEADER_KEY_MAP[FARMER_VERIFY_HEADER.DEFAULT];
